'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$22() {
  this.bfQ = null;
  this.bfO = null;
  this.bfP = false;
  this.bfM = null;
  this.bfN = false;
  this.bfR = false;
  this.bfS = false;
  this.bfQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$22 as $c_Lpresto_PrestoRouter$$anon$22 };
$p = $c_Lpresto_PrestoRouter$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$22;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$22() {
}
export { $h_Lpresto_PrestoRouter$$anon$22 as $h_Lpresto_PrestoRouter$$anon$22 };
$h_Lpresto_PrestoRouter$$anon$22.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfQ;
});
$p.t = (function() {
  if ((!this.bfP)) {
    this.bfO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfP = true;
  }
  return this.bfO;
});
$p.ae = (function() {
  if ((!this.bfN)) {
    this.bfM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfN = true;
  }
  return this.bfM;
});
$p.w = (function() {
  if ((!this.bfS)) {
    this.bfR = false;
    this.bfS = true;
  }
  return this.bfR;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$22, "presto.PrestoRouter$$anon$22", ({
  NM: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$22 as $d_Lpresto_PrestoRouter$$anon$22 };
//# sourceMappingURL=presto.-Presto-Router$$anon$22.js.map
